import { render, staticRenderFns } from "./GymRouteAscent.vue?vue&type=template&id=5ad62c82"
import script from "./GymRouteAscent.vue?vue&type=script&lang=js"
export * from "./GymRouteAscent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports